module.exports = __webpack_public_path__ + "static/img/currency-bg.be5040d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/currency-bg.jpg
// module id = AUKS
// module chunks = 0